import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as AdvisoryBoardOffersActions from './advisory-board-offers.actions';
import { OfferService } from '@/service/offer.service';
import {
  OfferWithImage,
  OfferWithImageHTTPResponse,
} from '@/model/offer-with-image';

@Injectable()
export class AdvisoryBoardOffersEffects {
  loadAdvisoryBoardOffers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdvisoryBoardOffersActions.loadAdvisoryBoardOffers),
      switchMap(({ categoryIds }) => {
        if (!categoryIds || categoryIds.length === 0) {
          return of(
            AdvisoryBoardOffersActions.loadAdvisoryBoardOffersSuccess({
              offers: [],
            }),
          );
        }

        // Use the new GraphQL query for advisory board offers
        const query = `
          query getAdvisoryBoardOffers($categoryIds: [ID!]!) {
            offersForAdvisoryBoard(categoryIds: $categoryIds) {
              id
              name
              description
              companyId
              imageUrl
              appointmentDateTime
              videoEmbeddedLink
              status
              orte {
                id
                name
                plz
              }
              bezirke {
                id
                name
              }
              bundeslaender {
                id
                name
              }
              categories {
                id
                name
              }
              offerType {
                id
                offerName
                acceptedMimeType
                requiresDate
                icon
              }
            }
          }
        `;

        const variables = {
          categoryIds,
        };

        return this.offerService.http
          .post<{
            data: {
              offersForAdvisoryBoard: OfferWithImageHTTPResponse[];
            };
          }>(`${this.offerService['apiUrl']}`, { query, variables })
          .pipe(
            map((response) => {
              const offers = response.data.offersForAdvisoryBoard.map((offer) =>
                OfferWithImage.fromHTTPResponse(offer),
              );
              return AdvisoryBoardOffersActions.loadAdvisoryBoardOffersSuccess({
                offers,
              });
            }),
            catchError((error) => {
              console.error('Error loading advisory board offers:', error);
              return of(
                AdvisoryBoardOffersActions.loadAdvisoryBoardOffersFailure({
                  error: 'Failed to load advisory board offers',
                }),
              );
            }),
          );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private offerService: OfferService,
  ) {}
}
